import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { ownerApi, type GetOwnersParams, type GetOwnersResponse } from 'services/ownerApi'
import { ownerQueryKeys } from './ownerQueryKeys'
import { useMemo } from 'react'

type UseOwnersQueryOptions = Omit<UseQueryOptions<GetOwnersResponse>, 'queryKey' | 'queryFn'>

export const useOwnersQuery = (params: GetOwnersParams = {}, options?: UseOwnersQueryOptions) => {
  // Create stable params object to prevent unnecessary refetches
  const stableParams = useMemo(() => params, [JSON.stringify(params)])

  const query = useQuery({
    queryKey: ownerQueryKeys.list(stableParams),
    queryFn: () => ownerApi.getOwners(stableParams),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
    ...options,
  })

  return {
    data: query.data || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
  }
}
